(function() {

	var lazyLoadedImages = '.js-lazyload-max-width';
	var $lazyLoadedImages = $(lazyLoadedImages);

	function applyMaxWidth() {
		if (!$lazyLoadedImages.length) {
			return;
		}
		$lazyLoadedImages.each(function(i, img) {
			var $img = $(img);
			var maxWidth = $img.data('max-width');
			var maxWidth_crispImage = maxWidth / _dpr;
			$img.css('max-width', maxWidth_crispImage + 'px');
		});
	}

	//	======================================================================  //
	//	Before unveil
	//	======================================================================  //

	_$document.on('lazybeforeunveil', function() {
		applyMaxWidth();
	});

})();
